import { useEffect, useState } from "react";

const languages = [
  {
    code: "en",
    name: "English",
    flag: "🇬🇧",
  },
  {
    code: "hi",
    name: "Hindi",
    flag: "🇮🇳",
  },
  {
    code: "ar",
    name: "Arabic",
    flag: "🇦🇪",
  },
  {
    code: "fr",
    name: "French",
    flag: "🇫🇷",
  },
  {
    code: "de",
    name: "German",
    flag: "🇩🇪",
  },
  {
    code: "es",
    name: "Spanish",
    flag: "🇪🇸",
  },
  {
    code: "it",
    name: "Italian",
    flag: "🇮🇹",
  },
  {
    code: "pt",
    name: "Portuguese",
    flag: "🇵🇹",
  },
  {
    code: "ru",
    name: "Russian",
    flag: "🇷🇺",
  },
  {
    code: "zh-CN",
    name: "Chinese",
    flag: "🇨🇳",
  },
  {
    code: "ja",
    name: "Japanese",
    flag: "🇯🇵",
  },
];

const GoogleTranslate = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");

    if (savedLanguage) {
      setSelectedLanguage(savedLanguage);
    }
  }, []);

  useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,hi,ar,fr,de,es,it,pt,ru,zh-CN,ja",
            autoDisplay: false,
          },
          "google_translate_element",
        );
      }
    };

    if (!document.querySelector('script[src*="translate.google.com"]')) {
      const script = document.createElement("script");

      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

      script.async = true;

      document.body.appendChild(script);
    }

    return () => {
      delete window.googleTranslateElementInit;
    };
  }, []);

  useEffect(() => {
    const hideGoogleElements = () => {
      /* Google top banner */
      const banner = document.querySelector(".goog-te-banner-frame");

      if (banner) {
        banner.style.display = "none";
      }

      /* Google iframe banner */
      const iframes = document.querySelectorAll("iframe.goog-te-banner-frame");

      iframes.forEach((iframe) => {
        iframe.style.display = "none";
      });

      /* Google tooltip */
      const tooltips = document.querySelectorAll(".goog-tooltip");

      tooltips.forEach((tooltip) => {
        tooltip.style.display = "none";
      });

      /* Body position added by Google */
      document.body.style.top = "0px";
    };

    hideGoogleElements();

    const interval = setInterval(hideGoogleElements, 300);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const changeLanguage = (languageCode) => {
    setSelectedLanguage(languageCode);

    localStorage.setItem("selectedLanguage", languageCode);

    setIsOpen(false);

    const googleSelect = document.querySelector(".goog-te-combo");

    if (!googleSelect) {
      console.log("Google Translate is not loaded yet");

      return;
    }

    googleSelect.value = languageCode;

    googleSelect.dispatchEvent(
      new Event("change", {
        bubbles: true,
      }),
    );

    setTimeout(() => {
      document.body.style.top = "0px";

      const banner = document.querySelector(".goog-te-banner-frame");

      if (banner) {
        banner.style.display = "none";
      }
    }, 500);
  };

  const selected =
    languages.find((language) => language.code === selectedLanguage) ||
    languages[0];

  return (
    <>
      {/* Google Translate Hidden Container */}
      <div
        id="google_translate_element"
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          overflow: "hidden",
          opacity: 0,
          pointerEvents: "none",
          left: "-9999px",
        }}
      />

      {/* Custom Language Dropdown */}
      <div
        className="relative"
        style={{
          zIndex: 9999,
        }}
      >
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50"
        >
          <span className="text-lg">{selected.flag}</span>

          <span>{selected.name}</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-2 max-h-80 w-52 overflow-y-auto rounded-xl border border-gray-200 bg-white p-1 shadow-xl">
            {languages.map((language) => (
              <button
                key={language.code}
                type="button"
                onClick={() => changeLanguage(language.code)}
                className={`flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm transition ${
                  selectedLanguage === language.code
                    ? "bg-gray-100 font-semibold text-gray-900"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                <span className="text-lg">{language.flag}</span>

                <span>{language.name}</span>

                {selectedLanguage === language.code && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="ml-auto"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default GoogleTranslate;
